/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createVoucher } from '../fn/admin-vouchers-api/create-voucher';
import { CreateVoucher$Params } from '../fn/admin-vouchers-api/create-voucher';
import { deleteVoucher } from '../fn/admin-vouchers-api/delete-voucher';
import { DeleteVoucher$Params } from '../fn/admin-vouchers-api/delete-voucher';
import { getAllVouchers } from '../fn/admin-vouchers-api/get-all-vouchers';
import { GetAllVouchers$Params } from '../fn/admin-vouchers-api/get-all-vouchers';
import { getVoucher } from '../fn/admin-vouchers-api/get-voucher';
import { GetVoucher$Params } from '../fn/admin-vouchers-api/get-voucher';
import { getVoucherUsages } from '../fn/admin-vouchers-api/get-voucher-usages';
import { GetVoucherUsages$Params } from '../fn/admin-vouchers-api/get-voucher-usages';
import { PageDtoVoucherUsageVoucherUsageDto } from '../models/page-dto-voucher-usage-voucher-usage-dto';
import { PageDtoVoucherVoucherDto } from '../models/page-dto-voucher-voucher-dto';
import { patchVoucher } from '../fn/admin-vouchers-api/patch-voucher';
import { PatchVoucher$Params } from '../fn/admin-vouchers-api/patch-voucher';
import { updateVoucher } from '../fn/admin-vouchers-api/update-voucher';
import { UpdateVoucher$Params } from '../fn/admin-vouchers-api/update-voucher';
import { VoucherDto } from '../models/voucher-dto';

@Injectable({ providedIn: 'root' })
export class AdminVouchersApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVoucher()` */
  static readonly GetVoucherPath = '/api/admin/vouchers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoucher()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoucher$Response(params: GetVoucher$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
    return getVoucher(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVoucher$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoucher(params: GetVoucher$Params, context?: HttpContext): Observable<VoucherDto> {
    return this.getVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<VoucherDto>): VoucherDto => r.body)
    );
  }

  /** Path part for operation `updateVoucher()` */
  static readonly UpdateVoucherPath = '/api/admin/vouchers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVoucher()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVoucher$Response(params: UpdateVoucher$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
    return updateVoucher(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVoucher$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVoucher(params: UpdateVoucher$Params, context?: HttpContext): Observable<VoucherDto> {
    return this.updateVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<VoucherDto>): VoucherDto => r.body)
    );
  }

  /** Path part for operation `deleteVoucher()` */
  static readonly DeleteVoucherPath = '/api/admin/vouchers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVoucher()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVoucher$Response(params: DeleteVoucher$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteVoucher(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVoucher$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVoucher(params: DeleteVoucher$Params, context?: HttpContext): Observable<void> {
    return this.deleteVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchVoucher()` */
  static readonly PatchVoucherPath = '/api/admin/vouchers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchVoucher()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchVoucher$Response(params: PatchVoucher$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
    return patchVoucher(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchVoucher$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchVoucher(params: PatchVoucher$Params, context?: HttpContext): Observable<VoucherDto> {
    return this.patchVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<VoucherDto>): VoucherDto => r.body)
    );
  }

  /** Path part for operation `getAllVouchers()` */
  static readonly GetAllVouchersPath = '/api/admin/vouchers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllVouchers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllVouchers$Response(params?: GetAllVouchers$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoVoucherVoucherDto>> {
    return getAllVouchers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllVouchers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllVouchers(params?: GetAllVouchers$Params, context?: HttpContext): Observable<PageDtoVoucherVoucherDto> {
    return this.getAllVouchers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoVoucherVoucherDto>): PageDtoVoucherVoucherDto => r.body)
    );
  }

  /** Path part for operation `createVoucher()` */
  static readonly CreateVoucherPath = '/api/admin/vouchers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVoucher()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVoucher$Response(params: CreateVoucher$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
    return createVoucher(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVoucher$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVoucher(params: CreateVoucher$Params, context?: HttpContext): Observable<VoucherDto> {
    return this.createVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<VoucherDto>): VoucherDto => r.body)
    );
  }

  /** Path part for operation `getVoucherUsages()` */
  static readonly GetVoucherUsagesPath = '/api/admin/vouchers/{id}/usages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoucherUsages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoucherUsages$Response(params: GetVoucherUsages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoVoucherUsageVoucherUsageDto>> {
    return getVoucherUsages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVoucherUsages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoucherUsages(params: GetVoucherUsages$Params, context?: HttpContext): Observable<PageDtoVoucherUsageVoucherUsageDto> {
    return this.getVoucherUsages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoVoucherUsageVoucherUsageDto>): PageDtoVoucherUsageVoucherUsageDto => r.body)
    );
  }

}
